import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaRegClock,
  FaEnvelope,
  FaPhoneAlt,
  FaTimes,
  FaBars,
} from "react-icons/fa";
import "./Header.scss";

import navbarPets from "../assets/images/navbar-pets.png";

// ÜST SEGMENT
const TopHeader = () => {
  return (
    <div className="top-header">
      <div className="top-header__container">
        <div className="top-header__contact-item">
          <FaRegClock className="icon" />
          <span>
            Hafta içi : 09.00 - 19.00 / Cumartesi : 09.00 - 19.00 / Pazar :
            Kapalı
          </span>
        </div>
        <div className="top-header__contact-item">
          <FaEnvelope className="icon" />
          <span>vetizmirveterinerklinigi@gmail.com</span>
        </div>
        <div className="top-header__pets">
          <img src={navbarPets} alt="pets" />
        </div>
      </div>
    </div>
  );
};

// ALT SEGMENT
const BottomHeader = () => {
  // 1. Menünün açık/kapalı durumunu tutacak state'i ekliyoruz
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // 2. State'i değiştirecek fonksiyonu tanımlıyoruz
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Mevcut durumun tersini ayarla
  };

  return (
    <div className="bottom-header">
      {/* 3. Mobil menü açıkken body'e scroll'u engelleyen bir class ekliyoruz */}
      <div className={`bottom-header__container `}>
        <div className="bottom-header__left-content">
          <NavLink to="/" onClick={() => setIsMenuOpen(false)}>
            <div className="bottom-header__logo">
              <img src="/logo.png" alt="Pati Dostu Logo" />
            </div>
          </NavLink>
          {/* 4. Navigasyonu ve Telefon Butonunu kapsayıcı bir dive alıyoruz */}
          <div
            className={`bottom-header__nav-wrapper ${
              isMenuOpen ? "show-menu" : ""
            }`}
          >
            <nav className="bottom-header__nav">
              <NavLink to="/" onClick={() => setIsMenuOpen(false)}>
                Ana Sayfa
              </NavLink>
              <NavLink to="/hakkimizda" onClick={() => setIsMenuOpen(false)}>
                Hakkımızda
              </NavLink>
              <NavLink
                to="/pati-hikayeleri"
                onClick={() => setIsMenuOpen(false)}
              >
                Pati Hikayeleri
              </NavLink>
              <NavLink to="/iletisim" onClick={() => setIsMenuOpen(false)}>
                İletişim
              </NavLink>
            </nav>

            <NavLink to="/hekimlerimizden">
              <button className="bottom-header__link-button  bottom-header__link-button-mobile">
                Vet İzmir Blog / Hekimlerimiz
              </button>
            </NavLink>
            <div className="bottom-header__phone-cta bottom-header__phone-cta-mobile">
              <div className="icon-wrapper">
                <FaPhoneAlt className="icon" />
              </div>
              <span className="phone-number">+90 538 597 04 41</span>
            </div>
          </div>
        </div>

        <div className="bottom-header__button-collector">
          <NavLink to="/hekimlerimizden">
            <button className="bottom-header__link-button bottom-header__link-button-desktop">
              Vet İzmir Blog / Hekimlerimiz
            </button>
          </NavLink>
          <div className="bottom-header__phone-cta  bottom-header__phone-cta-desktop">
            <div className="icon-wrapper">
              <FaPhoneAlt className="icon" />
            </div>
            <span className="phone-number">+90 538 597 04 41</span>
          </div>
        </div>

        {/* 5. Hamburger menü ikonunu ekliyoruz */}
        <div className="bottom-header__hamburger-menu" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </div>
  );
};

// ANA HEADER COMPONENT'İ
const Header = () => {
  return (
    <header className="site-header-wrapper">
      <TopHeader />
      <BottomHeader />
    </header>
  );
};

export default Header;
